import type { AppStandardMetrics } from './app-standard-metrics';

export const useStandardMetrics = (): {
  appStandardMetrics?: AppStandardMetrics;
} => {
  return {
    appStandardMetrics: window.cogniteGlobalStandardMetrics,
  };
};
